// @ts-nocheck
import { GetInitialStateInner } from 'Jsx/Utils/getBaseInitialState';

import { AppProps } from './App';
import { RawPageData } from './types';

const getInitialState: GetInitialStateInner<AppProps, RawPageData> = ({
  landing,
}) => {
  return {
    landing,
  };
};

export default getInitialState;
